import { useEffect, useMemo, useState } from "react";
import { MdPalette } from "react-icons/md";
import { useFilters } from "features/filters/store";
import useMapData from "../../hooks/useMapData";
import { normalizeAndGroupByDate } from "./utils";
import { 
    Container,
    MapLegendColor,
    MapLegendContent,
    MapLegendContentItem,
    MapLegendDate,
    MapLegendHeader,
    MapLegendHeaderTitle,
    MapLegendStats,
    MapLegendTotalItem,
    MapLegendTotalLabel,
    MapLegendTotals,
    MapLegendTotalValue,
    IconStyled,
    ContentFlex
} from "./styles";

export function MapInfo() {
    const { filters: { tabBarSessaoPlanejamentoOperacional, menuName } } = useFilters();
    const showCronogramaLegend =
        tabBarSessaoPlanejamentoOperacional === 'execucao-operacional'
        && menuName === 'Mapa Cronograma';

    const mapInfo = useMapData((s) => s.mapInfo);
    const datas = useMapData((s) => s.datas);
    const sidebarMenuOpen = useMapData((s) => s.sidebarMenuOpen);
    const listTalhoesIds = useMapData((s) => s.listTalhoesIds);
    const listTalhoesSize = listTalhoesIds?.size ?? 0;

    const [qtdeTalhaoSelectedHa, setQtdeTalhaoSelectedHa] = useState(0);

    const datasInfo = useMemo(() => {
        if (!showCronogramaLegend) return [];
        const mapListInfo = mapInfo?.features?.filter((feature: any) =>
            feature.properties?.planosoperacionais && feature.properties?.planosoperacionais.length > 0
        );
        return normalizeAndGroupByDate(mapListInfo, datas!, false);
    }, [showCronogramaLegend, mapInfo, datas]);

    const dataInfoInformation = useMemo(() => {
        if (!showCronogramaLegend) return [];
        const mapListInfo = mapInfo?.features?.filter((feature: any) =>
            feature.properties?.planosoperacionais && feature.properties?.planosoperacionais.length > 0
        );
        return normalizeAndGroupByDate(mapListInfo, datas!, true);
    }, [showCronogramaLegend, mapInfo, datas]);

    useEffect(() => {
        if (!showCronogramaLegend) return;
        if (!listTalhoesSize) {
            setQtdeTalhaoSelectedHa(0);
            return;
        }
        const talhoesSelecteds = datasInfo.filter((item) => listTalhoesIds.has(item.id));
        const totalAreaHa = talhoesSelecteds.reduce((acc, item) => {
            return acc + item.tamanhoAreaHa;
        }, 0);
        setQtdeTalhaoSelectedHa(Number(totalAreaHa.toFixed(2)));
    }, [showCronogramaLegend, listTalhoesSize, listTalhoesIds, datasInfo]);

    const selectedColors = useMemo(() => {
        const colors = new Set<string>();
        if (!listTalhoesSize) return colors;
        datasInfo.forEach((item: any) => {
            if (item?.id != null && listTalhoesIds.has(item.id) && item?.color) {
                colors.add(String(item.color).toUpperCase());
            }
        });
        return colors;
    }, [datasInfo, listTalhoesIds, listTalhoesSize]);

    return showCronogramaLegend && mapInfo && datasInfo.length > 0 ? (
        <Container isOpenMenu={sidebarMenuOpen}>
            <MapLegendHeader>
                <MapLegendHeaderTitle><MdPalette size={20} /> Legenda</MapLegendHeaderTitle>
            </MapLegendHeader>
                <MapLegendContent>
                    {
                        dataInfoInformation
                        ?.map((item: any) => (
                                <MapLegendContentItem key={`${item?.date}-${item?.color}`}>
                                    <MapLegendColor
                                        backgroundColor={item?.color}
                                        $selected={selectedColors.has(String(item?.color || "").toUpperCase())}
                                    />
                                    <MapLegendDate>
                                        {item?.date}
                                    </MapLegendDate>
                                    <MapLegendStats>
                                        {item?.talhoesQtde} talhões • {item?.tamanhoAreaHa} ha
                                    </MapLegendStats>
                                </MapLegendContentItem>
                            
                        ))
                    }
                </MapLegendContent>
                <MapLegendContent>
                    <ContentFlex>
                        <IconStyled />
                        <div>
                            <h4>Contador Visual</h4>
                            <p>Fundo cinza identifica talhões com múltiplas operações no mesmo dia, (N) exibe a quantidade de operações programada.</p> 
                        </div>
                    </ContentFlex>
                </MapLegendContent>
                <MapLegendTotals>
                    <MapLegendTotalItem>
                        <MapLegendTotalLabel>Talhões selecionados</MapLegendTotalLabel>
                        <MapLegendTotalValue>{listTalhoesIds.size ?? 0}</MapLegendTotalValue>
                    </MapLegendTotalItem>
                    <MapLegendTotalItem>
                        <MapLegendTotalLabel>Área total</MapLegendTotalLabel>
                        <MapLegendTotalValue>{qtdeTalhaoSelectedHa} ha</MapLegendTotalValue>
                    </MapLegendTotalItem>
                </MapLegendTotals>
        </Container>
    ) : null
}